import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@core/services/loader-service/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, finalize, map, retry, throwError, timer } from 'rxjs';

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {

  private totalRequests = 0;

  constructor(
    private router: Router,
    private loadingService: LoaderService,
    private toastService: ToastrService
  ) { }

  shouldRetry(error: HttpErrorResponse) {
    if (error.status === 503) {
      return timer(500);
    }
    throw error;
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.url == "https://graph.microsoft.com/v1.0/me") {
      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          setHeaders: {
            'content-type': 'application/json',
          },
        });
        request = request.clone({
          headers: request.headers.set('Accept', 'application/json'),
        });
      }
    }
    else {

      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          setHeaders: {
            'content-type': 'application/json',
          },
        });
      }

      request = request.clone({
        headers: request.headers.set('Accept', 'application/json'),
      });
    }

    request = request.clone({
      headers: request.headers.set('Cache-Control', 'no-cache'),
    });

    request = request.clone({
      headers: request.headers.set('Expires', '0'),
    });
    request = request.clone({
      headers: request.headers.set('Pragma', 'no-cache'),
    });

    this.totalRequests++;
    this.loadingService.setLoading(true);

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      retry({ count: 3, delay: this.shouldRetry }),
      catchError((error: HttpErrorResponse) => {
        if (error.status && (error.status === 404 || error.status === 401 || error.status === 503) && error.url === "https://graph.microsoft.com/v1.0/me/photo/$value") {

        } else if (error.status && error.status === 401) {
          this.toastService.error("Unauthorised. Sorry, your request couldn't be processed.", '',)
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else if (error && error.status && error.status === 409) { }
        else if (error.status == 0) {
          // this.toastService.error('', "Oops, something went wrong. Please try again later.")
        }
        else if (error && error.status && error.status === 500) {
          if (typeof error.error === 'object') {
            this.toastService.error('', error.error.detail);
          } else {
            this.toastService.error('', error.error);
          }
        }
        else if (error.error) {
          if (typeof error.error === 'object') {
            this.toastService.error('', error.error.detail);
          } else {
            this.toastService.error('', error.error);
          }
        }
        return  throwError(error);
      }), finalize(() => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.loadingService.setLoading(false);
        }
      })
    );
  }
}
